import { bandM, BAND_COLOR } from "@/lib/ui";

const pct = v => (Math.min(Math.max(v, 0), 5) / 5) * 100;
const zoneBg = `linear-gradient(90deg, var(--pr-bg) 0 ${pct(2.55)}%, var(--md-bg) ${pct(2.55)}% ${pct(3.55)}%, var(--gd-bg) ${pct(3.55)}% ${pct(4.55)}%, var(--ex-bg) ${pct(4.55)}% 100%)`;

function ProfRow({ r }) {
  const bb = bandM(r.v), over = r.v !== null && r.v > 5;
  const w = r.w !== null ? r.w.toFixed(2) : "—";
  const tip = r.v !== null ? `<b>${r.ind}</b><br>Score <span class='num'>${r.v.toFixed(2)}</span>${bb ? " · " + bb : ""}<br>Indicator weight <span class='num'>${w}</span>${over ? "<br>Above the 1–5 scale: sources were added together" : ""}` : null;
  return (
    <div className="ip-row">
      <div className="ip-name"><b>{r.ind}</b><span>weight {w}</span></div>
      <div className="ip-track" style={{ background: zoneBg }}>{r.v !== null ? <i className="ip-bar" style={{ width: `${pct(r.v)}%`, background: over ? "var(--red)" : BAND_COLOR[bb] }} data-tip={tip}></i> : <em>No data</em>}</div>
      <div className="ip-val">{r.v !== null ? <span className={`score-cell ${over ? "raw" : bb}`}><b>{r.v.toFixed(2)}{over ? " ▲" : ""}</b></span> : <span className="muted">—</span>}</div>
    </div>
  );
}

const Axis = () => (
  <div className="ip-row ip-axis" aria-hidden="true"><div></div><div className="ip-ticks">{[0, 1, 2, 3, 4, 5].map(t => <span key={t} style={{ left: `${t * 20}%` }}>{t}</span>)}</div><div></div></div>
);

export function ProfileCard({ o }) {
  const has = o.profile.length > 0;
  return (
    <div className="card span-5 ip-card" data-testid="indicator-profile"><div className="card-head"><div><h2>Indicator profile</h2><p className="sub">Each indicator's score out of 5. The background shows the rating bands, and the bar takes the colour of its band.</p></div></div>
      <div className="ip-rows" role="img" aria-label="Indicator scores on a 0 to 5 scale">{has ? o.profile.map(r => <ProfRow key={r.ind} r={r} />) : <p className="empty">No indicator data for this selection.</p>}{has ? <Axis /> : null}</div></div>
  );
}
